import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail';

window.theme.block('headline-gallery-slider', el => {
    const swiper = el.querySelector('.js-gallery');
    const swiperLightbox = el.querySelector('.swiper-wrapper');

    if (swiperLightbox) {
        lightGallery(swiperLightbox, {
            plugins: [lgThumbnail],
            thumbnail: true,
            mode: 'lg-fade',
            zoomFromOrigin: true,
            download: false,
            speed: 500,
            getCaptionFromTitleOrAlt: false,
            selector: '.gallery-item',
        });
    }

    if (swiper) {
        new window.theme.packages.swiper(swiper, {
            slidesPerView: 1.0000001,
            spaceBetween: 30,
            speed: 600,
            loop: true,
            navigation: {
                prevEl: el.querySelector('.js-prev'),
                nextEl: el.querySelector('.js-next')
            },
        });
    }
});
